export default "__VITE_ASSET__669480bd__"